import { Component, Input, OnInit, signal } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { SessionStoreService } from '@frontend/vanilla/core';

import { EpcotConfigService } from '../../../common/epcot-config.service';
import { MyBetsBet, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsUtilService } from '../../services/my-bets-util.service';

@Component({
    selector: 'ms-my-bets-betslip-expand',
    templateUrl: 'my-bets-betslip-expand.component.html',
    styleUrl: 'my-bets-betslip-expand.component.scss',
})
export class MyBetsBetslipExpandComponent implements OnInit {
    @Input({ required: true }) betslipId: string;
    @Input({ required: true }) myBetsListContext: MyBetsListContext;
    @Input({ required: true }) bets: MyBetsBet[];

    collapsed = false;
    isEpcotEnabled = false;
    isBetbuilderCombo = false;
    legsLabel = signal('');

    constructor(
        private sessionStore: SessionStoreService,
        private epcotConfigService: EpcotConfigService,
        private tracker: TrackingService,
        private sitecoreMyBets: SitecoreMyBetsConfig,
        public myBetsUtilService: MyBetsUtilService,
    ) {}

    ngOnInit(): void {
        const state = this.getExpandState();
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
        this.isBetbuilderCombo = this.bets ? this.bets.some((bet) => bet.betBuilderInfo) : false;
        if (this.betslipId && state[this.betslipId] !== undefined) {
            this.collapsed = state[this.betslipId];
        } else {
            this.collapsed = true;
        }
        this.setLegsLabel();
    }

    toggleClick($event: Event): void {
        const target = $event.target as HTMLElement;

        if (target && target.children && target.children.length) {
            const targetChild = target.children[0] as HTMLElement;

            if (targetChild.className.toString()?.indexOf('ds-button') > -1) {
                return;
            }
        }

        this.collapsed = !this.collapsed;
        this.trackToggleClick(this.collapsed);
        this.setLegsLabel();

        if (this.betslipId) {
            const state = this.getExpandState();
            state[this.betslipId] = this.collapsed;
            this.setExpandState(state);
        }
    }

    getExpandState(): { [id: string]: boolean } {
        const state = this.sessionStore.get<{ [id: string]: boolean }>('betslipExpand');

        if (!state) {
            return {};
        }

        return state;
    }

    setExpandState(state: { [id: string]: boolean }): void {
        this.sessionStore.set('betslipExpand', state);
    }

    private setLegsLabel() {
        this.legsLabel.set(this.collapsed ? this.sitecoreMyBets.myBets.ViewLegs : this.sitecoreMyBets.myBets.HideLegs);
    }

    private trackToggleClick(isCollapsed: boolean): void {
        this.tracker.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betting',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'myBets',
            [trackingConstants.COMPONENT_ACTION_EVENT]: isCollapsed ? 'collapse' : 'expand',
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.myBetsListContext.listType ? this.myBetsListContext.listType : 'not applicable',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'myBets',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: this.bets?.length ? 'parlay ' + this.bets?.length + ' bets' : 'parlay 1 bet',
            [trackingConstants.COMPONENT_URL_CLICKED]: 'not applicable',
        });
    }
}
